import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = localStorage.getItem("role");

  if (!user) {
    return <Navigate to="/" />; // Redirect to login if not authenticated
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/dashboard" />; // Redirect unauthorized users
  }

  return children;
};

export default ProtectedRoute;
